import {appQuery} from "./utils_request";

export const addBusinessPartner = () => {
    let filename = document.getElementById('filename').value;

    appQuery(urls.sparkCreateBusinessPartner.replace('toRpFilename', filename))
        .then(resp => {
            if(resp.valid){
                if(resp.hasOwnProperty('result') && resp.result.hasOwnProperty('cardCode')){
                    openForm('OCRD',resp.result.cardCode);
                    window.location = urls.sparkDashboardSynchro;
                }
            } else {
                alert(resp.error);
            }
        })
}

export const updateBusinessPartner = () => {
    let filename = document.getElementById('filename').value;

    appQuery(urls.sparkUpdateBusinessPartner.replace('toRpFilename', filename))
        .then(resp => {
            if(resp.valid){
                window.location = urls.sparkDashboardSynchro;
            } else {
                alert(resp.error);
            }
        })
}

export const removeDemand = () => {
    let filename = document.getElementById('filename').value;

    appQuery('/spark/remove_demand/' + filename)
        .then(resp => {
            window.location = '/spark/dashboard';
        })
}



// WEBPACK FOOTER //
// ./assets/js/spark.js